/**
 * ? @description : Create Student Profile By Admin
 */

// Dependencies
import React, { useState } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// CSS
import "../../../../css/StudentByAdmin.css";

// Axios Component
import Axios from "../../../../axios/Axios";

// Snackbar Component
import { showSnackbar } from "../../../redux/features/appSlice";

function StudentByAdmin() {
  // * Redux Variable
  const dispatch = useDispatch();

  // * Router Variable
  const navigate = useNavigate();

  // * Logged User Name
  const username = sessionStorage.getItem("username");

  // * State Variables
  const [loading, setLoading] = useState(false);
  const [studentData, setStudentData] = useState({
    student_name: "",
    whatsappno: "",
    sponser_name: "",
    sponser_contactno: "",
    sponser_address: "",
    student_age: "",
    spoken_language_1: "",
    education: "",
    level_reading_skill: "",
    class_contactno: "",
    student_status: "active",
    role: "student",
    group_status: "ungrouped",
    student_mapped_status: "unmapped",
    is_terms_agreed: true,
    spoken_language_2: null,
    spoken_language_3: null,
    spoken_language_4: null,
    spoken_language_5: null,
    spoken_language_6: null,
    group_id: null,
    group_name: null,
    map_id: null,
    medium_education: null,
    parent_name: null,
    parent_contactno: null,
    mapped_to_teacher: null,
    batch_member_id: null,
    created_by: username,
  });
  const [studentValidation, setStudentValidation] = useState({
    isInvalidStudentName: false,
    isInvalidStudentNameFormate: false,
    isInvalidClassContactNo: false,
    isInvalidStudentWhatsapp: false,
    isInvalidClassContactNoFormate: false,
    isInvalidStudentWhatsappFormate: false,
    isInvalidSponsorName: false,
    isInvalidSponsorNameFormate: false,
    isInvalidSponsorNumber: false,
    isInvalidSponsorNumberFormate: false,
    isInvalidSponsorAddress: false,
    isInvalidStudentAge: false,
    isInvalidStudentLanguage: false,
    isInvalidStudentEducation: false,
    isInvalidStudentReadingSkill: false,
    isInvalidStudentReadingSkillFormate: false,
  });
  const [otherField, setOtherField] = useState(false)

  // TODO : Mobile number Validation Pattern
  const checkInvalidNumber = (number) => {
    var pattern = new RegExp(
      /^\d+$/
    );
    var result = pattern.test(number);
    return !result;
  }
  // TODO : Name field validation pattern 

  const checkInvalidName = (name) => {
    var pattern = new RegExp(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/);
    var result = pattern.test(name);
    return !result;
  }

  // TODO : Form Validation
  const studentFormValidation = () => {
    var submitButton = true;
    var invalidStudentName = false;
    var invalidStudentNameFormate = false;
    var invalidClassContactNo = false;
    var invalidStudentWhatsapp = false;
    var invalidClassContactNoFormate = false;
    var invalidStudentWhatsappFormate = false;
    var invalidSponsorName = false;
    var invalidSponsorNameFormate = false;
    var invalidSponsorNumber = false;
    var invalidSponsorNumberFormate = false;
    var invalidSponsorAddress = false;
    var invalidStudentAge = false;
    var invalidStudentLanguage = false;
    var invalidStudentEducation = false;
    var invalidStudentReadingSkill = false;
    var invalidStudentReadingSkillFormate = false;

    if (
      studentData.student_name.length === 0 ||
      studentData.student_name.length > 30
    ) {
      invalidStudentName = true;
      submitButton = false;
    } else if (checkInvalidName(studentData.student_name)) {
      invalidStudentNameFormate = true;
      submitButton = false;
    }

    if (!(studentData.class_contactno.length === 10)) {
      invalidClassContactNo = true;
      submitButton = false;
    } else {
      if (checkInvalidNumber(studentData.class_contactno)) {
        invalidClassContactNoFormate = true;
        submitButton = false;
      }
    }

    if (!(studentData.whatsappno.length === 10)) {
      invalidStudentWhatsapp = true;
      submitButton = false;
    } else {
      if (checkInvalidNumber(studentData.whatsappno)) {
        invalidStudentWhatsappFormate = true;
        submitButton = false;
      }
    }

    if (
      studentData.sponser_name.length === 0 ||
      studentData.sponser_name.length > 30
    ) {
      invalidSponsorName = true;
      submitButton = false;
    } else if (checkInvalidName(studentData.sponser_name)){
      invalidSponsorNameFormate = true;
      submitButton = false;
    }

    if (!(studentData.sponser_contactno.length === 10)) {
      invalidSponsorNumber = true;
      submitButton = false;
    } else {
      if (checkInvalidNumber(studentData.sponser_contactno)) {
        invalidSponsorNumberFormate = true;
        submitButton = false;
      }
    }

    if (studentData.sponser_address.length === 0) {
      invalidSponsorAddress = true;
      submitButton = false;
    }

    if (
      studentData.student_age.length === 0 ||
      parseInt(studentData.student_age) < 8 ||
      parseInt(studentData.student_age) > 71
    ) {
      invalidStudentAge = true;
      submitButton = false;
    }

    if (
      studentData.spoken_language_1.length === 0 ||
      studentData.spoken_language_1.length > 30
    ) {
      invalidStudentLanguage = true;
      submitButton = false;
    }

    if (
      studentData.education.length === 0 ||
      studentData.education.length > 50
    ) {
      invalidStudentEducation = true;
      submitButton = false;
    }

    if (studentData.level_reading_skill.length === 0) {
      invalidStudentReadingSkill = true;
      submitButton = false;
    } else if (checkInvalidName(studentData.level_reading_skill)) {
      invalidStudentReadingSkillFormate = true;
      submitButton = false;
    }

    setStudentValidation({
      ...studentValidation,
      isInvalidStudentName: invalidStudentName,
      isInvalidStudentNameFormate: invalidStudentNameFormate,
      isInvalidClassContactNo: invalidClassContactNo,
      isInvalidStudentWhatsapp: invalidStudentWhatsapp,
      isInvalidClassContactNoFormate: invalidClassContactNoFormate,
      isInvalidStudentWhatsappFormate: invalidStudentWhatsappFormate,
      isInvalidSponsorName: invalidSponsorName,
      isInvalidSponsorNameFormate: invalidSponsorNameFormate,
      isInvalidSponsorNumber: invalidSponsorNumber,
      isInvalidSponsorNumberFormate:invalidSponsorNumberFormate,
      isInvalidSponsorAddress: invalidSponsorAddress,
      isInvalidStudentAge: invalidStudentAge,
      isInvalidStudentLanguage: invalidStudentLanguage,
      isInvalidStudentEducation: invalidStudentEducation,
      isInvalidStudentReadingSkill: invalidStudentReadingSkill,
      isInvalidStudentReadingSkillFormate:invalidStudentReadingSkillFormate,
    });
    return submitButton;
  };

  // ? Post Method : Create Student Profile By Admin
  async function postData() {
    try {
      setLoading(true)
      let finaldata = {
        ...studentData,
        is_under_eighteen: parseInt(studentData.student_age) < 18 ? true : false,
      };

      let options = {
        method: "POST",
        url: "/student",
        auth: true,
        data: finaldata,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 201 && response.data.message === "Student information created successfully!") {
        // console.log(response);
        setLoading(false)
        dispatch(
          showSnackbar({
            message: "Student data submitted successfully !",
            severity: "success",
          })
        );

        setTimeout(() => {
          navigate("/category/students")
        }, 2000)

      }
    } catch (error) {
      setLoading(false)
      if (error.status === 400) {
        dispatch(
          showSnackbar({
            message: "Student profile already exists, Try with different Name and Phone number",
            severity: "error",
          })
        );
      } else {
        dispatch(
          showSnackbar({
            message: "Error occurred while creating student profile. Please try again later.",
            severity: "error",
          })
        );
      }

    }
  }

  return (
    <div>
      <Row>
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 8, offset: 2 }}
          lg={{ span: 8, offset: 2 }}
          xl={{ span: 6, offset: 3 }}
        >
          {/* Title */}
          <h1 className="mt-3 student-title">
            Let's Teach English - Waitlist a Student
          </h1>

          {/* Form */}
          <Form>
            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Name <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="student_name"
                placeholder="Name"
                value={studentData.student_name}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    student_name: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentName: false,
                    isInvalidStudentNameFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentName || studentValidation.isInvalidStudentNameFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidStudentName ? 'Student name is mandatory and should be less than 30 characters.' : ''}
                {studentValidation.isInvalidStudentNameFormate ? 'Student name should consist only of alphabetical values.' : ''}

                {/* Student name is mandatory and should be less than 30 characters. */}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Phone Number <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="tel"
                name="class_contactno"
                placeholder="Number"
                value={studentData.class_contactno}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    class_contactno: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidClassContactNo: false,
                    isInvalidClassContactNoFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidClassContactNo || studentValidation.isInvalidClassContactNoFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidClassContactNo ? ' Student number is mandatory and must contains 10 digits.':''}
               {studentValidation.isInvalidClassContactNoFormate ? 'Student phone number is not valid': ''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Student's WhatsApp Number If different from the above phone
                number&nbsp;
                <span style={{ color: "red" }}>*</span>
                <br />
                <p style={{ color: "gray", fontSize: "10px" }}>
                  Note : Please copy the above number if same number is used for
                  WhatsApp
                </p>
              </Form.Label>

              <Form.Control
                type="tel"
                name="whatsappno"
                placeholder="WhatsApp Number"
                value={studentData.whatsappno}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    whatsappno: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentWhatsapp: false,
                    isInvalidStudentWhatsappFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentWhatsapp || studentValidation.isInvalidStudentWhatsappFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidStudentWhatsapp ? 'Student WhatsApp number is mandatory and must contains 10 digits.' : ''}
                {studentValidation.isInvalidStudentWhatsappFormate ? 'Student WhatsApp number is not valid':''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Sponsor's Name&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="sponser_name"
                placeholder="Sponsor's Name"
                value={studentData.sponser_name}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_name: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorName: false,
                    isInvalidSponsorNameFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorName || studentValidation.isInvalidSponsorNameFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidSponsorName ? 'Sponsor name is mandatory and should be less than 30 characters.': ''}
                {studentValidation.isInvalidSponsorNameFormate ? 'Sponsor name should consist only of alphabetical values.': ''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Sponsor's Phone Number&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="tel"
                name="sponser_contactno"
                placeholder="Sponsor's Number"
                value={studentData.sponser_contactno}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_contactno: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorNumber: false,
                    isInvalidSponsorNumberFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorNumber || studentValidation.isInvalidSponsorNumberFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidSponsorNumber ? 'Sponsor number is mandatory and must contains 10 digits.': ''}
               {studentValidation.isInvalidSponsorNumberFormate ? 'Sponsor number is not valid.': ''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Sponsor's Residence&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Check
                type="radio"
                name="sponser_address"
                label="APR Villas"
                value="APR Villas"
                reverse
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_address: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorAddress: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />

              <Form.Check
                type="radio"
                name="sponser_address"
                label="APR Towers"
                value="APR Towers"
                reverse
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_address: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorAddress: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />

              <Form.Check
                type="radio"
                label="Others"
                // value="others"
                name="sponser_address"
                onClick={() => setOtherField((prev) => !prev)}
                // checked={otherField} 
                reverse
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />
              {otherField && (<Form.Control
                type="text"
                name="sponser_address"
                value={studentData.sponser_address}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_address: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorAddress: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />)}


              <Form.Control.Feedback type="invalid">
                Sponsor address is mandatory.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Student's Age<span style={{ color: "red" }}>*</span>
                <br />
                <p style={{ color: "gray", fontSize: "10px" }}>
                  Note : Student should be over 8 to be able to enroll in this programme
                </p>
              </Form.Label>

              <Form.Control
                name="student_age"
                type="number"
                min={8}
                max={60}
                placeholder="Age"
                value={studentData.student_age}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    student_age: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentAge: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentAge}
              />

              <Form.Control.Feedback type="invalid">
                Student Age is mandatory and must be greater than or equal to
                age 8 and not over 70.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Spoken Language - 1&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_1"
                placeholder="First Language"
                value={studentData.spoken_language_1}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_1: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentLanguage: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentLanguage}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_1}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_1: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentLanguage: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentLanguage}
              >
                <option value="">Select one language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Urdu">Urdu</option>

              </Form.Select>

              <Form.Control.Feedback type="invalid">
                Spoken Language is mandatory.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 2</Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_2"
                placeholder="Second Language"
                value={studentData.spoken_language_2}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_2: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_2}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_2: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Urdu">Urdu</option>

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 3</Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_3"
                placeholder="Third Language"
                value={studentData.spoken_language_3}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_3: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_3}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_3: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Urdu">Urdu</option>

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 4</Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_4"
                placeholder="Fourth Language"
                value={studentData.spoken_language_4}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_4: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_4}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_4: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Urdu">Urdu</option>

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 5</Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_5"
                placeholder="Fifth Language"
                value={studentData.spoken_language_5}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_5: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_5}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_5: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Urdu">Urdu</option>

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 6</Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_6"
                placeholder="Sixth Language"
                value={studentData.spoken_language_6}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_6: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_6}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_6: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Kannada">Kannada</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Urdu">Urdu</option>

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Highest Level of Education&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="education"
                placeholder="Education"
                value={studentData.education}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    education: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentEducation: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentEducation}
              />

              <Form.Control.Feedback type="invalid">
                Education level is mandatory and should not exceeds 50
                characters.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Medium of Education&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="medium_of_education"
                placeholder="Medium of Education"
                value={studentData.level_reading_skill}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                    isInvalidStudentReadingSkillFormate:false
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill || studentValidation.isInvalidStudentReadingSkillFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidStudentReadingSkill? 'Medium of Education is mandatory and should not exceeds 50 characters.' : ''}
                {studentValidation.isInvalidStudentReadingSkillFormate? 'The student Medium of Education should consist only of alphabetical values.': ''}.
              </Form.Control.Feedback>

              {/* <Form.Check
                type="radio"
                name="level_reading_skill"
                label="Beginner"
                value="Beginner"
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill}
              />

              <Form.Check
                type="radio"
                name="level_reading_skill"
                label="Intermediate"
                value="Intermediate"
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill}
              />

              <Form.Check
                type="radio"
                name="level_reading_skill"
                label="Advanced"
                value="Advanced"
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill}
              />

              <Form.Control.Feedback type="invalid">
                Reading skill is mandatory.
              </Form.Control.Feedback> */}
            </Form.Group>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <Button
                type="button"
                variant="light"
                className="student-cancel"
                onClick={() => navigate(-1)}
              >
                CANCEL
              </Button>

              <Button
                type="submit"
                variant="primary"
                className="student-submit"
                onClick={(e) => {
                  e.preventDefault();
                  var isValid = studentFormValidation();
                  if (isValid) postData();
                  else
                    dispatch(
                      showSnackbar({
                        message: "Please fill all the mandatory fields.",
                        severity: "error",
                      })
                    );
                }}
              >
                SUBMIT
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
      {loading && <div id="backdrop">
        <Spinner style={{
          display: "block",
          position: "fixed",
          top: "calc(50% - (58px / 2))",
          right: "calc(50% - (58px / 2))",
        }} animation="border" variant="primary" />
      </div>}
    </div>
  );
}

export default StudentByAdmin;
